import {setMaxAmountForCartItem} from './setMaxAmountForCartItem'

export function setMaxAmountForEachItem({items}) {
    for (const index in items) {
        items[index] = setMaxAmountForCartItem({cartItem: items[index]})
    }

    return items
}